export class ObjEvents {

    public static event_path_open:string = "/GRAFLOW/obj/path_open"
    public static event_path_close_request:string = "/GRAFLOW/obj/path_close_request"


    public static list_status_changed:string = "/GRAFLOW/obj/list_status_changed"
    public static status_changed:string = "/GRAFLOW/obj/status_changed"
    

    public static event_update:string = "/GRAFLOW/obj/updated"
    public static event_insert:string = "/GRAFLOW/obj/inserted"
    public static event_delete:string = "/GRAFLOW/obj/deleted"

    public static api_update:string = "/api/mqtt/obj/update"
    public static api_insert:string = "/api/mqtt/obj/insert"
    public static api_delete:string = "/api/mqtt/obj/delete"

}